import { Grid, TextField } from '@mui/material';
import React, { useState } from 'react';
import { Company } from '../../api/api-generated';
import {
  useCreateCompanyMutation,
  useDeleteCompanyMutation,
  useFindAllCompaniesQuery,
  useFindOneCompanyQuery,
  useUpdateCompanyMutation,
} from '../../api/api-hooks';
import ItemOptionsBar from '../../components/ItemOptionsBar';
import { Item } from '../../utils/sharedTypes';
import { nullStringCheck } from '../../utils/stringManipulation';
import DepartmentsButton from '../departments/DepartmentsButton';
import { CompanyForm } from './companyTypes';

interface Props {
  selectedCompanies: Item[];
  setSelectedCompanies: React.Dispatch<React.SetStateAction<Item[]>>;
}

const addFormInitialState: CompanyForm = {
  companyName: '',
};

const CompaniesOptionsBar = ({
  selectedCompanies,
  setSelectedCompanies,
}: Props) => {
  const [deleteCompany] = useDeleteCompanyMutation();
  const [createCompany] = useCreateCompanyMutation();
  const [editCompany] = useUpdateCompanyMutation();
  const [editModalOpenFlag, setEditModalOpenFlag] = useState<boolean>(false);
  const { data: companies } = useFindAllCompaniesQuery({});
  if (companies === undefined) return <></>;
  return (
    <>
      <ItemOptionsBar
        selectedItems={selectedCompanies}
        setSelectedItems={setSelectedCompanies}
        handlerMiddleware={(name, value, state) => ({})}
        itemValidator={(item: any) => {
          if (!item.companyName) return false;
          return true;
        }}
        formInstructions='Company name is required.'
        editModalOpen={editModalOpenFlag}
        setEditModalOpen={setEditModalOpenFlag}
        addFormInitialState={addFormInitialState}
        itemName='Company'
        deleteNotes='Deleting a company will delete all associated data, including hardware, software, RMAs, and orders. Please use caution.'
        childrenCreator={(addFormState: CompanyForm, handler: any) => (
          <Grid container direction='column' spacing={1}>
            <Grid item>
              <TextField
                margin='dense'
                name='companyName'
                label='Company Name'
                fullWidth
                value={nullStringCheck(addFormState.companyName)}
                onChange={handler}
              />
            </Grid>
            <Grid item>
              <DepartmentsButton
                company={
                  selectedCompanies[0] as Pick<
                    Company,
                    'id' | 'companyName' | 'supportPurchases' | 'departments'
                  >
                }
              />
            </Grid>
          </Grid>
        )}
        itemCreator={(item: CompanyForm) => {
          if (!item.companyName)
            return { error: { data: { message: 'Missing required fields' } } };
          return createCompany({
            createCompanyDto: {
              companyName: item.companyName,
            },
          });
        }}
        itemGetter={useFindOneCompanyQuery}
        itemUpdater={(item: CompanyForm) => {
          if (!item.companyName)
            return { error: { data: { message: 'Missing required fields' } } };
          return editCompany({
            id: Number(selectedCompanies[0].id),
            updateCompanyDto: {
              id: Number(selectedCompanies[0].id),
              companyName: item.companyName,
            },
          });
        }}
        itemDeleter={deleteCompany}
      />
    </>
  );
};

export default CompaniesOptionsBar;
